// useSharedDynamicModal.ts
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../store";
import {IModalProps } from "../interfaces/components";
import { closeIcdTree } from "../store/features/components/icdTreeSlice";
import { closeDialog, openDialog } from "../store/features/components/modalSlice";


interface SharedDynamicModalOptions extends IModalProps {}

/**
 *
 * @returns
 */
const useSharedDynamicModal = () => {
  const dispatch = useDispatch();

  const {
    confirm,
    open,
    message,
    isFormModal,
    component,
    title,
    confirmButton,
    cancelButton,
    size,
    fetchHook,
    hookParams,
    type,
  } = useSelector((state: RootState) => state.modal);

  /**
   *
   * @param options
   */
  const openSharedDynamicModal = (options: SharedDynamicModalOptions) => {
    dispatch(openDialog(options));
  };

  /**
   *
   */
  const closeSharedDynamicModal = () => {
    dispatch(closeDialog());
    dispatch(closeIcdTree())
  };

  return {
    open,
    confirm,
    confirmButton,
    cancelButton,
    size,
    component,
    message,
    title,
    isFormModal,
    fetchHook,
    hookParams,
    type,
    openSharedDynamicModal,
    closeSharedDynamicModal,
  };
};

export default useSharedDynamicModal;
